import { convertHexToDecimal } from '../../../utils/index.js';
import { LabelStatuses } from '../../../types/index.js';
const checkIfLabelStatusStringContains = (labelStatusValue, labelStatus) => {
    return (labelStatusValue & labelStatus) > 0;
};
export const parseLabelStatuses = (labelStatusValue) => {
    const labelStatuses = [];
    const labelStatusDecimalValue = convertHexToDecimal(labelStatusValue);
    for (const labelStatus in LabelStatuses) {
        if (checkIfLabelStatusStringContains(labelStatusDecimalValue, LabelStatuses[labelStatus])) {
            labelStatuses.push(labelStatus);
        }
    }
    return labelStatuses;
};
